import React, {useState, useEffect} from 'react';
import {Checkbox, Button, Popconfirm} from 'antd';
import styles from './layout.module.less'
import store from "../store";
import projectStore from "../../user/project/store";
import {observer} from 'mobx-react';
import lodash from 'lodash'


// the hook
import {useTranslation} from 'react-i18next';

export default observer(function (props) {
  const {t} = useTranslation();
  const {record, index} = props
  const {selectedCustomKeys} = store
  const [project, setProject] = useState([])

  // useEffect(() => {
  //   const curProject = projectStore.records.filter(v => {
  //     return v.id * 1 === record['extra_sn'] * 1
  //   })
  //   setProject(curProject)
  // }, [])

  const delRow = () => {
    store.delRecord(record.id, index, true)
  }

  const handleCheck = (e, id) => {
    if (e.target.checked && selectedCustomKeys.indexOf(id) === -1) {
      selectedCustomKeys.push(id)
    }
    if (!e.target.checked) {
      lodash.remove(selectedCustomKeys, v => v === id)
    }
  }

  const handleEdit = () => {
    record.isEdit = true
  }

  return (
    <React.Fragment>
      <div className={[styles.formRow, styles.formRowShow].join(" ")}
           key={record.id ? record.id : index}
           style={{lineHeight: '0.1666rem'}}>
        <div className={styles.td1}>
          <Checkbox disabled={!record.id} onChange={(e) => handleCheck(e, record.id)}/>
        </div>
        <div className={styles.td2}>
          <div className={[styles.badge, record.catalog  !== "Sale" ? styles.badgeGhost : ''].join(' ')}>
            {record.catalog === 'Sale' ? t('购') : t('租')}
          </div>
        </div>
        <div className={styles.td3}>{record.name}</div>
        <div className={styles.td4}>{record.brand}</div>
        <div className={styles.td5}>{record.formats}</div>
        <div className={styles.td6}>{record.factory_code}</div>
        <div className={styles.td7}>{record.desc}</div>
        <div className={styles.td8}>{record.number}</div>
        {/* <div className={styles.td9}>{project.length ? project[0].name + '[' + project[0].sn + ']' : ''}</div>
        <div className={styles.td11}>{record.is_measure ? t('是') : t('否')}</div> */}
        <div style={{flex: 1}}/>
        <div className={styles.td12}>
          <div className={styles.rowBtn}>
            <Button size={'small'} onClick={handleEdit}>{t('编辑')}</Button>

            <Popconfirm
              title={t('确定删除吗?')}
              onConfirm={delRow}
              okText={t('确定')}
              cancelText={t('取消')}
            >
              <span className={['icon icon-del', styles.del].join(" ")}/>
            </Popconfirm>
          </div>
        </div>
      </div>
    </React.Fragment>
  )
})


